export default __webpack_public_path__ + "static/media/books-1440w.12c5a937.avif";